// 费率计算
import base from '../base'
import { request } from '../http'

export default {
  insuranceList: promise => request('get', `${base.api.zlbUrl}/api/v1/insurance/list`, promise), // 获取险种
  regionPage: (parentCode, promise) => request('get', `${base.api.zlbUrl}/api/v1/consumer/order/region/list/${parentCode}`, promise), // 地区接口
  findRate: promise => request('post', `${base.api.zlbUrl}/api/v1/consumer/order/o2frzmdhcgflehjl/find/rate`, promise), // 查看费率
  calculatePrice: promise => request('post', `${base.api.zlbUrl}/api/v1/consumer/order/o2frzmdhcgflehjl/calculate/price`, promise) // 计算保费

}
